export const AnalyticsData = {
  Authorizations: {
    TransactionsCompleted: {
      numberOfTransctionsRange: {
        min: 2000,
        max: 3500,
      },
      percentFromLastRange: {
        min: 10,
        max: 40,
      },
    },
    NeedsInterventions: {
      numberOfTransctionsRange: {
        min: 200,
        max: 400,
      },
      percentFromLastRange: {
        min: 2,
        max: 15,
      },
    },
    haveSaved: {
      hours: {
        min: 50,
        max: 200,
      },
      money: {
        min: 10_990,
        max: 12_990,
      },
      FTE: {
        min: 2.5,
        max: 6.6,
      },
    },
    ThroughputPerHour: {
      transactions: {
        min: 233,
        max: 600,
      },
      avgMinTransctions: {
        min: 1,
        max: 10,
      },
    },
    chartOneDataPoints: {
      byDay: {
        rangeMin: 100,
        rangeMax: 400,
        length: 30,
      },
      byWeek: {
        rangeMin: 200,
        rangeMax: 400,
        length: 30,
      },
    },
    chartTwoDataPoints: {
      rangeMin: 0,
      rangeMax: 50,
      length: 11,
    },
  },
  ClaimsSubmission: {
    TransactionsCompleted: {
      numberOfTransctionsRange: {
        min: 2000,
        max: 3500,
      },
      percentFromLastRange: {
        min: 10,
        max: 40,
      },
    },
    NeedsInterventions: {
      numberOfTransctionsRange: {
        min: 200,
        max: 400,
      },
      percentFromLastRange: {
        min: 2,
        max: 15,
      },
    },
    haveSaved: {
      hours: {
        min: 50,
        max: 200,
      },
      money: {
        min: 10_990,
        max: 12_990,
      },
      FTE: {
        min: 2.5,
        max: 6.6,
      },
    },
    ThroughputPerHour: {
      transactions: {
        min: 233,
        max: 600,
      },
      avgMinTransctions: {
        min: 1,
        max: 10,
      },
    },
    chartOneDataPoints: {
      byDay: {
        rangeMin: 100,
        rangeMax: 400,
        length: 30,
      },
      byWeek: {
        rangeMin: 200,
        rangeMax: 400,
        length: 30,
      },
    },
    chartTwoDataPoints: {
      rangeMin: 0,
      rangeMax: 50,
      length: 11,
    },
  },
  EligibilityManagement: {
    TransactionsCompleted: {
      numberOfTransctionsRange: {
        min: 2000,
        max: 3500,
      },
      percentFromLastRange: {
        min: 10,
        max: 40,
      },
    },
    NeedsInterventions: {
      numberOfTransctionsRange: {
        min: 200,
        max: 400,
      },
      percentFromLastRange: {
        min: 2,
        max: 15,
      },
    },
    haveSaved: {
      hours: {
        min: 50,
        max: 200,
      },
      money: {
        min: 10_990,
        max: 12_990,
      },
      FTE: {
        min: 2.5,
        max: 6.6,
      },
    },
    ThroughputPerHour: {
      transactions: {
        min: 233,
        max: 600,
      },
      avgMinTransctions: {
        min: 1,
        max: 10,
      },
    },
    chartOneDataPoints: {
      byDay: {
        rangeMin: 100,
        rangeMax: 400,
        length: 30,
      },
      byWeek: {
        rangeMin: 200,
        rangeMax: 400,
        length: 30,
      },
    },
    chartTwoDataPoints: {
      rangeMin: 0,
      rangeMax: 50,
      length: 11,
    },
  },
  AlertManagement: {
    TransactionsCompleted: {
      numberOfTransctionsRange: {
        min: 2000,
        max: 7470,
      },
      percentFromLastRange: {
        min: 10,
        max: 40,
      },
    },
    NeedsInterventions: {
      numberOfTransctionsRange: {
        min: 200,
        max: 400,
      },
      percentFromLastRange: {
        min: 2,
        max: 15,
      },
    },
    haveSaved: {
      hours: {
        min: 50,
        max: 200,
      },
      money: {
        min: 10_990,
        max: 12_990,
      },
      FTE: {
        min: 2.5,
        max: 6.6,
      },
    },
    ThroughputPerHour: {
      transactions: {
        min: 233,
        max: 600,
      },
      avgMinTransctions: {
        min: 1,
        max: 10,
      },
    },
    chartOneDataPoints: {
      byDay: {
        rangeMin: 100,
        rangeMax: 400,
        length: 30,
      },
      byWeek: {
        rangeMin: 200,
        rangeMax: 400,
        length: 30,
      },
    },
    chartTwoDataPoints: {
      rangeMin: 0,
      rangeMax: 50,
      length: 11,
    },
  },
  MedicareEligibilityAlertMgmt: {
    TransactionsCompleted: {
      numberOfTransctionsRange: {
        min: 2000,
        max: 7470,
      },
      percentFromLastRange: {
        min: 10,
        max: 40,
      },
    },
    NeedsInterventions: {
      numberOfTransctionsRange: {
        min: 200,
        max: 400,
      },
      percentFromLastRange: {
        min: 2,
        max: 15,
      },
    },
    haveSaved: {
      hours: {
        min: 50,
        max: 200,
      },
      money: {
        min: 10_990,
        max: 12_990,
      },
      FTE: {
        min: 2.5,
        max: 6.6,
      },
    },
    ThroughputPerHour: {
      transactions: {
        min: 233,
        max: 600,
      },
      avgMinTransctions: {
        min: 1,
        max: 10,
      },
    },
    chartOneDataPoints: {
      byDay: {
        rangeMin: 100,
        rangeMax: 400,
        length: 30,
      },
      byWeek: {
        rangeMin: 200,
        rangeMax: 400,
        length: 30,
      },
    },
    chartTwoDataPoints: {
      rangeMin: 0,
      rangeMax: 50,
      length: 11,
    },
  },
  'Physician/FacilityNotification': {
    TransactionsCompleted: {
      numberOfTransctionsRange: {
        min: 2000,
        max: 7470,
      },
      percentFromLastRange: {
        min: 10,
        max: 40,
      },
    },
    NeedsInterventions: {
      numberOfTransctionsRange: {
        min: 200,
        max: 400,
      },
      percentFromLastRange: {
        min: 2,
        max: 15,
      },
    },
    haveSaved: {
      hours: {
        min: 50,
        max: 200,
      },
      money: {
        min: 10_990,
        max: 12_990,
      },
      FTE: {
        min: 2.5,
        max: 6.6,
      },
    },
    ThroughputPerHour: {
      transactions: {
        min: 233,
        max: 600,
      },
      avgMinTransctions: {
        min: 1,
        max: 10,
      },
    },
    chartOneDataPoints: {
      byDay: {
        rangeMin: 100,
        rangeMax: 400,
        length: 30,
      },
      byWeek: {
        rangeMin: 200,
        rangeMax: 400,
        length: 30,
      },
    },
    chartTwoDataPoints: {
      rangeMin: 0,
      rangeMax: 50,
      length: 11,
    },
  },
  OASIStoiQIES: {
    TransactionsCompleted: {
      numberOfTransctionsRange: {
        min: 2000,
        max: 7470,
      },
      percentFromLastRange: {
        min: 10,
        max: 40,
      },
    },
    NeedsInterventions: {
      numberOfTransctionsRange: {
        min: 200,
        max: 400,
      },
      percentFromLastRange: {
        min: 2,
        max: 15,
      },
    },
    haveSaved: {
      hours: {
        min: 50,
        max: 200,
      },
      money: {
        min: 10_990,
        max: 12_990,
      },
      FTE: {
        min: 2.5,
        max: 6.6,
      },
    },
    ThroughputPerHour: {
      transactions: {
        min: 233,
        max: 600,
      },
      avgMinTransctions: {
        min: 1,
        max: 10,
      },
    },
    chartOneDataPoints: {
      byDay: {
        rangeMin: 100,
        rangeMax: 400,
        length: 30,
      },
      byWeek: {
        rangeMin: 200,
        rangeMax: 400,
        length: 30,
      },
    },
    chartTwoDataPoints: {
      rangeMin: 0,
      rangeMax: 50,
      length: 11,
    },
  },
};

export const WorkFlowSummeryData = {
  RCD: {
    scheduled: {
      min: 50,
      max: 150,
    },
    wait: {
      min: 50,
      max: 150,
    },
    inProgress: {
      min: 50,
      max: 150,
    },
    failed: {
      min: 10,
      max: 30,
    },
    needsIntervention: {
      min: 50,
      max: 150,
    },
    completed: {
      min: 100,
      max: 150,
    },
  },
  Authorizations: {
    scheduled: {
      min: 50,
      max: 150,
    },
    wait: {
      min: 50,
      max: 150,
    },
    inProgress: {
      min: 50,
      max: 150,
    },
    failed: {
      min: 10,
      max: 30,
    },
    needsIntervention: {
      min: 50,
      max: 150,
    },
    completed: {
      min: 100,
      max: 150,
    },
  },
  ClaimsSubmission: {
    scheduled: {
      min: 50,
      max: 150,
    },
    wait: {
      min: 50,
      max: 150,
    },
    inProgress: {
      min: 50,
      max: 150,
    },
    failed: {
      min: 10,
      max: 30,
    },
    needsIntervention: {
      min: 50,
      max: 150,
    },
    completed: {
      min: 100,
      max: 150,
    },
  },
  EligibilityManagement: {
    scheduled: {
      min: 50,
      max: 150,
    },
    wait: {
      min: 50,
      max: 150,
    },
    inProgress: {
      min: 50,
      max: 150,
    },
    failed: {
      min: 10,
      max: 30,
    },
    needsIntervention: {
      min: 50,
      max: 150,
    },
    completed: {
      min: 100,
      max: 150,
    },
  },
  AlertManagement: {
    scheduled: {
      min: 50,
      max: 150,
    },
    wait: {
      min: 50,
      max: 150,
    },
    inProgress: {
      min: 50,
      max: 150,
    },
    failed: {
      min: 10,
      max: 30,
    },
    needsIntervention: {
      min: 50,
      max: 150,
    },
    completed: {
      min: 100,
      max: 150,
    },
  },
  MedicareEligibilityAlertMgmt: {
    scheduled: {
      min: 50,
      max: 150,
    },
    wait: {
      min: 50,
      max: 150,
    },
    inProgress: {
      min: 50,
      max: 150,
    },
    failed: {
      min: 10,
      max: 30,
    },
    needsIntervention: {
      min: 50,
      max: 150,
    },
    completed: {
      min: 100,
      max: 150,
    },
  },
  'Physician/FacilityNotification': {
    scheduled: {
      min: 50,
      max: 150,
    },
    wait: {
      min: 50,
      max: 150,
    },
    inProgress: {
      min: 50,
      max: 150,
    },
    failed: {
      min: 10,
      max: 30,
    },
    needsIntervention: {
      min: 50,
      max: 150,
    },
    completed: {
      min: 100,
      max: 150,
    },
  },
  OASIStoiQIES: {
    scheduled: {
      min: 50,
      max: 150,
    },
    wait: {
      min: 50,
      max: 150,
    },
    inProgress: {
      min: 50,
      max: 150,
    },
    failed: {
      min: 10,
      max: 30,
    },
    needsIntervention: {
      min: 50,
      max: 150,
    },
    completed: {
      min: 100,
      max: 150,
    },
  },
};
